<ng-container *ngIf="canUseFeature">
	<button mat-button type="button" *ngIf="!hideDocumentButton" (click)="activate()" class="doc-management-opener linq-opener-button"
		title="{{buttonTitle}}">
		<mat-icon>insert_drive_file</mat-icon>
		<span *ngIf="!hideButtonText">Manage Documents</span>
	</button>
	<ng-template cdk-portal>
		<div class="linq-drawer-content">
			<header class="linq-drawer-header">
				<h3 class="linq-heading">{{ flyoutHeaderTitle ? flyoutHeaderTitle : (editing ? 'Edit Document' : 'Documents') }}</h3>
				<button class="linq-drawer-header__close linq-button-close-lg" (click)="deactivate()">
					<mat-icon>clear</mat-icon>
				</button>
			</header>
			<div class="linq-drawer-inner-content linq-drawer-inner-content--spaced flyout-inner-container">
				<ng-container *ngIf="!editing">
					<mat-tab-group [(selectedIndex)]="tabSelectedIndex" (selectedTabChange)="onTabChange($event)"
						class="linq-tab-bar linq-tab-bar--fill-tabs">
						<mat-tab label="Existing Documents">
							<div *ngIf="!storedFiles.length" class="doc-management-no-data">
								<p *ngIf="isAccessible">Get started by <button (click)="setCurrentTab(1)">uploading</button> a document.</p>
								<p *ngIf="!isAccessible">No documents are associated with the current record.</p>
							</div>
							<mat-form-field *ngIf="storedFiles.length > 1">
								<mat-label>Sort</mat-label>
								<mat-select [(ngModel)]="sort">
									<mat-option *ngFor="let option of sortOptions; trackByItem" [value]="option">
										{{option}}
									</mat-option>
								</mat-select>
							</mat-form-field>
							<div class="linq-list-items">
								<div *ngFor="let storedFile of storedFiles; key: 'id'"
									[ngClass]="{ 'linq-list-item': true, 'linq-list-item--deleting': deleting.indexOf(storedFile.id) > -1 }">
									<div class="linq-list-item__icon">
										<mat-icon>{{ fileIcon(storedFile.name) }}</mat-icon>
									</div>
									<div class="linq-list-item__content">
										<h3 class="linq-heading linq-list-item__title">
											{{ storedFile.displayName }}
										</h3>
										<p *ngIf="storedFile.metadata?.Description" class="linq-list-item__description">{{
											storedFile.metadata.Description
											}}</p>
										<div *ngIf="hasTitle(storedFile)" class="linq-list-item__subtitle linq-list-item__filename">{{ storedFile.name
											}}
										</div>
										<div class="linq-list-item__subtitle">
											<mat-icon matTooltip="Confidential document" *ngIf="storedFile.metadata?.IsConfidential">lock</mat-icon>
											Added by {{ storedFile.owner }} on {{ displayDate(storedFile.updatedAt) }}
											<mat-checkbox *ngIf="sendAttachments" [disabled]="true" [(ngModel)]="storedFile.metadata.IsSendWithEmail">
												Send with email</mat-checkbox>
										</div>
									</div>
									<sl-kebab class="linq-list-item__action" [actions]="actions" entity="{{ storedFile.id }}"></sl-kebab>
								</div>
							</div>
						</mat-tab>
						<mat-tab [disabled]="isReadOnly" label="Upload">
							<form (ngSubmit)="(docMgmtForm.valid)" #docMgmtForm="ngForm" [formGroup]="metaDataForm">
								<div class="linq-file-upload">
									<sl-file-upload-dnd *ngIf="!filesToEdit.controls.length" (filesSelected)="handleSelectedFiles($event)">
									</sl-file-upload-dnd>
									<div *ngIf="filesToEdit.controls.length" class="linq-file-upload-file-list">
										<ng-container formArrayName="files" *ngFor="let file of filesToEdit.controls; let i = index;">
											<div *ngIf="files[file.controls.id.value]" class="linq-file-upload-file-group" [formGroupName]="i">
												<div
													class="linq-file-upload-file linq-file-upload-file--{{ files[file.controls.id.value].status.toLowerCase() }}">
													<span class="linq-file-upload-file__filename">{{ displayName(files[file.controls.id.value])
														}}</span>
													<button class="linq-file-upload-file__icon" mat-icon-button aria-label="Remove file"
														[disabled]="files[file.controls.id.value].status === 'DELETING'"
														(click)="removeFile(file.controls.id.value)">
														<mat-icon>close</mat-icon>
													</button>
													<div *ngIf="files[file.controls.id.value].status === 'PROCESSING'"
														class="linq-file-upload-file__progress">
														<mat-progress-bar class="linq-progress-indicator" mode="determinate"
															[value]="files[file.controls.id.value].progress">
														</mat-progress-bar>
													</div>
												</div>
												<ng-container *ngIf="files[file.controls.id.value].status === 'EDITING'">
													<fieldset id="file--{{ i }}">
														<legend>Edit info for file {{ files[file.controls.id.value].name }}</legend>
														<mat-form-field>
															<mat-label>Title</mat-label>
															<input formControlName="Title" requiredNoWhitespace matInput maxlength="255" />
															<mat-error *ngIf="file?.controls?.Title?.errors?.required">Title is required
															</mat-error>
														</mat-form-field>
														<mat-form-field>
															<mat-label>Description</mat-label>
															<textarea formControlName="Description" matInput maxlength="255"></textarea>
														</mat-form-field>
														<mat-checkbox *ngIf="hasConfidentialAccess" formControlName="IsConfidential">Confidential
														</mat-checkbox>
														<mat-checkbox *ngIf="sendAttachments" formControlName="IsSendWithEmail">Send with Email
														</mat-checkbox>
													</fieldset>
												</ng-container>
											</div>
										</ng-container>
									</div>
								</div>
							</form>
						</mat-tab>
					</mat-tab-group>
				</ng-container>
				<ng-container *ngIf="editing">
					<form (ngSubmit)="(docMgmtFormEdit.valid)" #docMgmtFormEdit="ngForm" *ngIf="!isReadOnly">
						<h4 class="doc-management-edit-title">{{ editing.name }}</h4>
						<mat-form-field>
							<mat-label>Title</mat-label>
							<input name="Title" [(ngModel)]="editing.metadata.Title" requiredNoWhitespace matInput maxlength="255" />
							<mat-error *ngIf="docMgmtFormEdit.form.controls?.Title?.errors?.required">Title is required</mat-error>
						</mat-form-field>
						<mat-form-field>
							<mat-label>Description</mat-label>
							<textarea name="Description" [(ngModel)]="editing.metadata.Description" matInput maxlength="255"></textarea>
						</mat-form-field>
						<mat-checkbox name="IsConfidential" *ngIf="hasConfidentialAccess" [(ngModel)]="editing.metadata.IsConfidential">
							Confidential</mat-checkbox>
						<mat-checkbox name="IsSendWithEmail" *ngIf="sendAttachments" [(ngModel)]="editing.metadata.IsSendWithEmail">Send with email
						</mat-checkbox>
					</form>
				</ng-container>
			</div>
			<footer *ngIf="tabSelectedIndex === 1 && files" class="linq-drawer-footer">
				<button type="button" mat-stroked-button class="linq-button--secondary" (click)="cancelUploading()">Cancel</button>
				<button type="button" mat-raised-button color="primary" [disabled]="formDisabled()" (click)="handleSubmitUpdating()">Save</button>
			</footer>
			<footer *ngIf="editing" class="linq-drawer-footer">
				<button type="button" mat-stroked-button class="linq-button--secondary" (click)="cancelEditing()">Cancel</button>
				<button type="button" mat-raised-button color="primary" [disabled]="formDisabled()" (click)="handleSubmitEditing()">Save</button>
			</footer>
		</div>
	</ng-template>

</ng-container>